const formatInt = (num: any) => {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
  }).format(num);
};

export default formatInt;
